import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import axios from 'axios'
import router from './router'
Vue.use(Vuex);

function setEnv() {
	var req = window.location;
	var env;
	var protocol;
	var urlAPI;

	switch (req.hostname) {
        case 'dev.todomath.com':
			env = 'dev';
			protocol = 'http://';
			urlAPI = 'devapi.todomath.com';
			break;
		case 'rc-todomath.us-west-2.elasticbeanstalk.com':
		case 'rc.todomath.com':
		case 'localhost':
			env = 'rc';
			protocol = 'https://';
			urlAPI = 'rcapi.todomath.com';
			break;
		default:
			env = 'live';
			protocol = 'https://';
			urlAPI = 'api.todomath.com';
			break;
	}

	return {
		env: env,
		protocol: protocol,
		urlAPI: urlAPI,
	}
}

export const store = new Vuex.Store({

	state: {
		lang: '',
		appStoreUrl: '',
		googlePlayUrl: '',
		parentEmail: '',
		sessionId: '',
		accountId: '',
        googleToken: '',
        email: '',
        password: '',
		errCode: '',
		env: setEnv(),
		cnDownloadUrl: '',
		appVersion: '',
		cnStaticDownloadUrl: ''
	},
	mutations: {
		setStoreLang(state, lang) {
			state.lang = lang;
		},
		setLanguage(state, lang) {
			var setLang = '';
			switch (lang) {
				case 'en':
				case 'ko':
				case 'cn':
				case 'ja':
					state.lang = lang;
					break;
				default:
					state.lang = 'en';
					break;
			}
			VueCookies.set('language', state.lang);
		},
		setToBrowserLanguage(state) {
			var browserLanguage = navigator.language || navigator.userLanguage;
			browserLanguage = browserLanguage ? browserLanguage : 'en';
			browserLanguage = browserLanguage.substring(0, 2);
			state.lang = browserLanguage;

			VueCookies.set('language', state.lang);

		},
		setAppStoreUrl(state, url) {
			state.appStoreUrl = url;
		},
		setGooglePlayUrl(state, url) {
			state.googlePlayUrl = url;
		},
		setIds(state, data) {
			if (window.location.hostname == 'localhost') {
				VueCookies.set('sessionId', data.sessionId, 60 * 60 * 24)
			} else {
				VueCookies.set('sessionId', data.sessionId, 60 * 60 * 24, null, 'todomath.com')
			}
			state.sessionId = data.sessionId;

			VueCookies.set('accountId', data.accountId, 60 * 60 * 24)
			state.accountId = data.accountId;
		},
		
		delIds(state) {
			VueCookies.remove('sessionId', null, 'todomath.com')
			VueCookies.remove('sessionId')
			state.sessionId = '';

			VueCookies.remove('accountId');
			state.accountId = '';
		},
		
        setGoogleToken(state, token) {
            state.googleToken = token;
            state.email = '';
            state.password = '';
        },
        delGoogleToken(state) {
			state.googleToken = '';
            state.email = '';
            state.password = '';
        },
        setEmailSignup(state, { email, password }) {
			state.email = email;
			state.password = password;
			state.googleToken = '';
        },
        delEmailSignup(state) {
			state.email = '';
			state.password = '';
			state.googleToken = '';
        },
		setErrCode(state, errCode) {
			state.errCode = errCode;
		},
		setCnDownloadUrl(state, url) {
			state.cnDownloadUrl = url
		},
		setAppVersion(state, appver) {
			state.appVersion = appver
		},
		setCnStaticDownloadUrl(state, url) {
			state.cnStaticDownloadUrl = url
		}
	},
	getters: {
		isSignedIn(state) {
			state.sessionId = state.sessionId || VueCookies.get('sessionId')
			return state.sessionId;
		},
		sessionId(state) {
			return state.sessionId != '' ? state.sessionId : VueCookies.get('sessionId')
		},
		accountId(state) {
			return state.accountId != '' ? state.accountId : VueCookies.get('accountId')
		}
	},
	actions: {
		signin({commit, state}, {email, password}) {
			return new Promise((resolve, reject) => {
				axios.post(state.env.protocol+state.env.urlAPI+'/account/signin', {
                    accountType: 'personal',
                    email: email,
                    password: password,
                    getSessionId: true,
                    product: 'todomath',
                    fromWeb: true
				}, {
					headers: {
						'content-type': 'application/json; charset=UTF-8'
					}
				}).then(function(rs) {
					if (!rs.data.result) {
						commit('delIds')
						// commit('delSessionId');
						commit('setErrCode', rs.data.errorCode);
						reject('error');
					} else {
						commit('setIds', rs.data.data)
						// commit('setSessionId', rs.data.data.sessionId);
						resolve(rs.data.data)
					}
				}).catch(function(er) {
					commit('delIds')
					// commit('delSessionId');
					commit('setErrCode', 'CA99');
					reject('error');
				});
			});
		},
		signinKakao({commit, state}, {token}) {
			return new Promise((resolve, reject) => {
				axios.post(state.env.protocol+state.env.urlAPI+'/account/signinKakaoOAuth', {
                    access_token: token,
                    product: 'todomath'
                } , {
					headers: {
						'content-type': 'application/json; charset=UTF-8'
					}
				}).then(function(rs) {
					if (!rs.data.result) {
						commit('delIds')
						// commit('delSessionId');
						commit('setErrCode', rs.data.errorCode);
						reject('error');
					} else {
						commit('setIds', rs.data.data)
						// commit('setSessionId', rs.data.data.sessionId);
						resolve();
					}
				}).catch(function(er) {
					commit('delIds')
					// commit('delSessionId');
					commit('setErrCode', 'CA99');
					reject('error');
				});
			});
		},
		signinGoogle({commit, state}, {token, marketingAgreement}) {
			return new Promise((resolve, reject) => {
				axios.post(state.env.protocol+state.env.urlAPI+'/account/signinGoogleOAuth', {
                    token: token,
                    marketingAgreement: marketingAgreement,
                    product: 'todomath'
				}, {
					headers: {
						'content-type': 'application/json; charset=UTF-8'
					}
				}).then(function(rs) {
					if (!rs.data.result) {
						commit('delIds')
						// commit('delSessionId');
						commit('setErrCode', rs.data.errorCode);
						reject('error');
					} else {
						commit('setIds', rs.data.data)
						// commit('setSessionId', rs.data.data.sessionId);
						resolve();
					}
				}).catch(function(er) {
					commit('delIds')
					// commit('delSessionId');
					commit('setErrCode', 'CA99');
					reject('error');
				});
			});
		},
		signout({commit}, {}) {
			commit('delIds')
			// commit('delSessionId');
        },

        redirect() {
            const { origin, search } = window.location;
            let path = "/";
            if (search) {
                const tokens = search.replace(/^\?/, "").split("&");
                for (let i = 0; i < tokens.length; i++) {
                    const pair = tokens[i].split("=");
                    if (decodeURIComponent(pair[0]) == "redirect") {
                        path = decodeURIComponent(pair[1]);
                    }
                }
            }
			
            if (path.startsWith('/')) {
                router.push(path)
            } else {
				window.location.href = path
			}
        },

        verifySession({commit, state}, {sessionId}) {
			return new Promise((resolve, reject) => {
				axios.post(state.env.protocol+state.env.urlAPI+'/session/verify', {
                    sessionId: sessionId
				}, {
					headers: {
						'content-type': 'application/json; charset=UTF-8'
					}
				}).then(function(rs) {
					if (!rs.data || !rs.data.result || !rs.data.data.accountId) {
						// commit('delSessionId');
						commit('delIds')
						reject('error');
					} else {
						resolve();
					}
				}).catch(function(er) {
					// commit('delSessionId');
					commit('delIds')
					reject('error');
				});
			});
        }
	}
});

VueCookies.get('language') ? store.commit('setStoreLang', VueCookies.get('language')) : store.commit('setToBrowserLanguage');



// WEBPACK FOOTER //
// ./src/store.js